import React, { Component } from "react";
import { Button, Switch, Popconfirm } from "antd";
import { COLORS } from "../pages/theme";
import {
  ChevronRight,
  ErrorOutline,
  DoneOutlined,
  CloseOutlined,
  PlayArrowRounded,
  ReplayRounded,
  PauseRounded,
  Cancel,
  AddCircle,
  LibraryAdd,
} from "@material-ui/icons";
import { Link } from "react-router-dom";

export const ScoredTag = ({ valuekey, value, score = 0 }) => {
  return (
    <div
      style={{
        borderRadius: 3,
        border: `1px solid ${COLORS.border_basic}`,
        paddingLeft: 8,
        paddingRight: 8,
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        margin: 2,
      }}
    >
      <span className="sub-heading-4 " style={{ marginRight: 6 }}>
        {valuekey ? `${valuekey} :` : valuekey} {value}
      </span>
      <span
        className="sub-heading-4 "
        style={{
          paddingLeft: 6,
          borderLeft: `1px solid ${COLORS.border_basic}`,
          color:
            score < 0.4
              ? COLORS.danger_primary
              : score > 0.8
                ? COLORS.success_primary
                : COLORS.warning_primary,
        }}
      >
        {(score * 100).toLocaleString()}%
      </span>
    </div>
  );
};

export const TabButton = ({
  type,
  label,
  style,
  active = false,
  onClick,
  labelStyle,
  hideIndicator,
  onRemove,
  onAdd,
  disabled,
  className = "",
}) => {
  let has_close_btn = typeof onRemove === "function";
  let has_add_btn = typeof onAdd === "function";

  return (
    <div
      onClick={() => {
        typeof onClick === "function" && onClick();
      }}
      className={`hand-cursor 
    ${type == "success" ? "success-outlined tab-btn" : "error-outlined tab-btn"}
    ${active && type == "success" ? "success-filled" : ""}
    ${active && type == "error" ? "error-filled" : ""}
    ${disabled ? "disabled-outlined" : ""}
    ${className}
    `}
      title={disabled ? "Excluded Processor" : null}
      style={{
        ...style,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        {!hideIndicator && <div className="btn-indicator"></div>}
        <div
          className="btn-label"
          style={{
            marginRight: has_close_btn ? 8 : 12,
            ...labelStyle,
          }}
        >
          {label}
        </div>

        {has_close_btn && !disabled && (
          <Popconfirm
            onConfirm={(e) => {
              e.stopPropagation();
              onRemove();
            }}
            onCancel={(e) => {
              e.stopPropagation();
            }}
            title="Are you sure you want to exclude this processor for this transaction?"
          >
            <Cancel
              className={`close-btn`}
              titleAccess="Exclude Processor"
              style={{
                height: 18,
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          </Popconfirm>
        )}
        {has_add_btn && disabled && (
          <Popconfirm
            onConfirm={(e) => {
              e.stopPropagation();
              onAdd();
            }}
            onCancel={(e) => {
              e.stopPropagation();
            }}
            title="Are you sure you want to include this processor for this transaction?"
          >
            <AddCircle
              className={`add-btn`}
              titleAccess="Include Processor"
              style={{
                height: 18,
              }}
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
              }}
            />
          </Popconfirm>
        )}
      </div>
    </div>
  );
};

export const IconButton = ({
  style,
  icon,
  label,
  title,
  onClick,
  className = "",
}) => {
  return (
    <div
      title={title || label}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flexWrap: "nowrap",
        ...style,
      }}
      className={`icon-btn hand-cursor ${className}`}
      onClick={(e) => {
        typeof onClick === "function" && onClick(e);
      }}
    >
      {icon}
      <span>{label}</span>
    </div>
  );
};
export const CustomButton = ({
  className,
  label,
  style,
  disabled = false,
  onClick,
  hideIndicator,
  hint,
  icon,
}) => {
  return (
    <div
      title={hint}
      onClick={() => {
        !disabled && typeof onClick === "function" && onClick();
      }}
      className={`hand-cursor ${className} ${disabled ? "btn-disabled" : ""}`}
      style={{
        marginLeft: 4,
        marginRight: 4,
        ...style,
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          paddingBottom: 4,
          paddingTop: 4,
          height: "100%",
          gap: 8,
        }}
      >
        {icon}
        {/* <LibraryAdd/> */}
        <div>{label}</div>
      </div>
    </div>
  );
};

export const TransparentButton = ({
  label,
  icon,
  hoverable,
  onClick,
  hint,
  className,
  labelStyle,
  disabled,
  iconStyle,
  loading,
}) => {
  return (
    <Button
      loading={loading}
      className={`${className || "cta-basic"} ${disabled ? "disabled_transparent" : ""
        }`}
      type="link"
      style={{
        color: "inherit",
        display: "flex",
        alignItems: "center",
      }}
      onClick={() => {
        if (!disabled) {
          typeof onClick === "function" && onClick();
        }
      }}
      title={hint}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          flexWrap: "nowrap",
        }}
      >
        {icon && (
          <React.Fragment>
            {React.cloneElement(icon, {
              style: {
                marginRight: 8,
                ...iconStyle,
              },
            })}
          </React.Fragment>
        )}
        <span
          style={{
            lineHeight: "100%",
            ...labelStyle,
          }}
        >
          {label}
        </span>
      </div>
    </Button>
  );
};

export const CustomSwitch = ({
  value,
  trueItem,
  falseItem,
  onChange,
  title,
  disabled,
  disabledTitle,
  style,
  className,
}) => {
  return (
    <div
      className={className}
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        ...style,
      }}
    >
      <span
        className="heading-2"
        onClick={() => {
          typeof onChange === "function" && onChange(trueItem);
        }}
        style={{
          fontWeight: value == trueItem ? "bold" : "normal",
          color: value == trueItem ? COLORS.primary : null,
        }}
      >
        {trueItem} &nbsp;
      </span>
      <Switch
        disabled={disabled}
        title={disabledTitle ? (disabled ? disabledTitle : title) : title}
        className="customSwitch"
        checked={value != trueItem}
        size="small"
        onChange={(value) => {
          console.log("value", value);
          typeof onChange === "function" &&
            onChange(value ? falseItem : trueItem);
        }}
      />
      <span
        className="heading-2"
        onClick={() => {
          typeof onChange === "function" && onChange(falseItem);
        }}
        style={{
          fontWeight: value != trueItem ? "bold" : "normal",
          color: value != trueItem ? COLORS.primary : null,
        }}
      >
        &nbsp; {falseItem}
      </span>
    </div>
  );
};

export const IconNoCard = ({
  type,
  icon,
  title,
  subtitle,
  style,
  link,
  parentStyle = {},
}) => {
  return (
    <div
      // className='default-card'
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        padding: 12,
        margin: 0,
        ...style,
      }}
    >
      <div className={`icon-holder ${type}-icon-holder`}>{icon}</div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          flex: 1,
          paddingLeft: 16,
        }}
      >
        {link ? (
          <Link to={link}>
            <span className={"heading-main"}>{title}</span>
          </Link>
        ) : (
          <span
            className={"sub-heading-2"}
            style={{
              color: COLORS.secondary,
            }}
          >
            {subtitle}
          </span>
        )}
        <span
          className={"sub-heading-2"}
          style={{
            color: COLORS.secondary,
          }}
        >
          {subtitle}
        </span>
      </div>
    </div>
  );
};

export const IconCard = ({
  type,
  icon,
  title,
  subtitle,
  style,
  link,
  parentStyle = {},
}) => {
  return (
    <Link to={link || "#"} style={parentStyle}>
      <div
        className="default-card"
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          padding: 12,
          margin: 0,
          ...style,
        }}
      >
        <div className={`icon-holder ${type}-icon-holder`}>{icon}</div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            flex: 1,
            paddingLeft: 20,
          }}
        >
          <span className={"heading-main"}>{title}</span>
          <span
            className={"sub-heading-2"}
            style={{
              color: COLORS.secondary,
            }}
          >
            {subtitle}
          </span>
        </div>
        {link && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
            }}
          >
            <ChevronRight
              style={{
                height: 32,
                width: 32,
              }}
            />
          </div>
        )}
      </div>
    </Link>
  );
};

export const TransactionOverviewStatistics = ({
  type = "small",
  label,
  title,
  subtitle,
  style,
}) => {
  return (
    <div
      className={`transaction-overview-statistics-${type}`}
      style={{
        display: "flex",
        flexDirection: "column",
        ...style,
      }}
    >
      <span className="label">{label}</span>
      <span className="title">{title}</span>
      <span className="subtitle">{subtitle}</span>
    </div>
  );
};

export const TextTag = ({ label, type = "success" }) => {
  return <div className={`text-tag text-tag-${type}`}>{label}</div>;
};
